import { isToday, isYesterday } from 'date-fns';
import { date } from '@frameio/i18n';
import TEXT from './generated/TEXT/groupByDateFormatted';

TEXT.DEFINE(
  {
    /** Label for today's date group */
    today: 'Today',
    /** Label for yesterday's date group */
    yesterday: 'Yesterday',
    formattedDate: (displayDate: Date): string => date(displayDate, 'medium'),
  },
  { date }
);

export const getGroupingDate = (inputDate: number | Date): string => {
  if (isToday(inputDate) || !inputDate) {
    return TEXT.today;
  }
  if (isYesterday(inputDate)) {
    return TEXT.yesterday;
  }
  const dateObj = inputDate instanceof Date ? inputDate : new Date(inputDate);
  return TEXT.formattedDate(dateObj);
};

type DateGrouping<T> = { [key: string]: Array<T> };

export const groupByDateFormatted = <T extends Record<string, any>>(
  arr: Array<T>,
  criteria: string
) => {
  return arr.reduce<DateGrouping<T>>((acc, currentValue) => {
    const itemDate = new Date(currentValue[criteria]);

    const dateGrouping = getGroupingDate(itemDate);

    if (!acc[dateGrouping]) {
      // eslint-disable-next-line no-param-reassign
      acc[dateGrouping] = [];
    }
    acc[dateGrouping].push(currentValue);
    return acc;
  }, {});
};
